// extracted by mini-css-extract-plugin
module.exports = {"skipToMainContent":"skip-to-main-content_skipToMainContent__m2xSF","hidden":"skip-to-main-content_hidden__j65z2","visible":"skip-to-main-content_visible__cqi7r"};